import {Component, HostListener, Input, OnDestroy, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../../ng2-bootstrap-modal/dialog.service';
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {HostingService} from "../../hosting.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbValidators} from "../../../../../shared/validators/DbValidators";
import {Subscription} from "rxjs";
import {DbServerErrors} from "../../../../../shared/interceptors/db-server-errors";
import {Utils} from "../../../../../shared/utils/utils";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../../store';
import {Website} from "../../../website";
import {IDsDropdownOption} from "../../../../../shared/components/ds-dropdown/ds-dropdown-option";

import {filter, first} from "rxjs/operators";


@Component({
    selector: 'db-add-dns-dialog',
    templateUrl: './add-dns-dialog.component.html',
    styleUrls: ['./add-dns-dialog.component.scss'],
    standalone: false
})
export class AddDnsDialogComponent extends DialogComponent<null, Boolean> implements OnInit, OnDestroy {

  @Input() zone: any;
  @Input() record: any;
  @Input() website: Website;
  @Input() zohoMxRecord: boolean = false;
  @Input() gmailMxRecord: boolean = false;
  @Input() isScrolling: boolean;
  showInstallMode;
  public loading: boolean;
  public formValueChanged: boolean = false;
  public changes: any;
  public formSubmitted: boolean;
  public formValid: boolean;
  public addRecordForm: FormGroup;
  public hasServerFieldErrors: boolean;
  public subscriptions: Subscription[];
  public ttlOptions: IDsDropdownOption[];
  public typesOptions: IDsDropdownOption[];
  public ttl: FormControl;
  public type: FormControl;
  public serverErrors: DbServerErrors;
  public alreadyExistRecord: any;
  public indexing: number = 0;
  public recordValue: string;
  public dnsRecordValue: any;
  public dnsMXRecordValue: any;
  public dnsSRVRecordValue: any;
  public dnsARecordValue: any;
  public dnsAAAARecordValue: any;

  public zohoMxRecordValue: string = "10 mx.zoho.com." + "\n" + "20 mx2.zoho.com." + "\n" + "50 mx3.zoho.com.";
  public txtRecordPlaceholder: string = "Enter multiple TXT values. Each new value should be entered from a new line." + "\n" + "Example:" + "\n" + "       Sample Text Entries";
  public ARecordPlaceholder: string = "Enter multiple A records. Each new value should be entered from a new line." + "\n" + "Example:" + "\n" + "       IPv4 Address";
  public AAAARecordPlaceholder: string = "Enter multiple AAAA records. Each new value should be entered from a new line." + "\n" + "Example:" + "\n" + "       IPv6 Address";
  public gmailMxRecordValue: string = "1 SMTP.GOOGLE.COM";


  constructor(
    private _dialogService: DialogService,
    private _hostingService: HostingService,
    private _store: Store<fromStore.DbStoreState>,
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.ttlOptions = [
      {
        label: "1 min",
        value: "60"
      },
      {
        label: "2 min",
        value: "120"
      },
      {
        label: "5 min",
        value: "300"
      },
      {
        label: "10 min",
        value: "600"
      },
      {
        label: "15 min",
        value: "900"
      },
      {
        label: "30 min",
        value: "1800"
      },
      {
        label: "1 hour",
        value: "3600"
      },
      {
        label: "2 hours",
        value: "7200"
      },
      {
        label: "5 hours",
        value: "18000"
      },
      {
        label: "12 hours",
        value: "43200"
      },
      {
        label: "1 day",
        value: "86400"
      },
    ];
    const types = ['A', 'CNAME', 'TXT', 'MX', 'PTR', 'SRV', 'AAAA'];
    const typesFormatted = [];
    types.forEach((key: string): void => {
      typesFormatted.push({
        "label": key,
        "value": key
      });
    });
    this.typesOptions = typesFormatted;

    this.ttl = new FormControl(this.record ? this.record.ttl.toString() : "3600", [Validators.required]);
    this.type = new FormControl(this.record ? this.record.type : (this.zohoMxRecord || this.gmailMxRecord ? "MX" : "CNAME"), [Validators.required]);
    this.dnsMXRecordValue = this.record?.type === 'MX' ? this.record.value.split("\n").filter(value => value !== '') : "";
    this.dnsSRVRecordValue = this.record?.type === 'SRV' ? this.record.value.split("\n").filter(value => value !== '') : "";
    this.dnsARecordValue = this.record?.type === 'A' ? this.record && this.record.value.split("\n").filter(value => value !== '') : "";
    this.dnsAAAARecordValue = this.record?.type === 'AAAA' ? this.record.value.split("\n").filter(value => value !== '') : "";
    this.dnsRecordValue = this.record?.value && this.record.type !== 'MX' && this.record.type !== 'SRV' && this.record.type !== 'A' && this.record.type !== 'AAAA' ? this.record.value.replace(/\"/g, "").replace(/\\/g, "'").trim() : "";
    this.addRecordForm = new FormGroup({
      'subdomain': new FormControl(this.record ? this.record.name.replace('.' + this.zone.name, '').replace(this.zone.name, '') : '', [DbValidators.trim, Validators.pattern(/^([a-zA-Z0-9-_@]([a-zA-Z0-9\-_@]{0,61}[a-zA-Z0-9-_@])?\.)*[a-zA-Z0-9-_@]([a-zA-Z0-9\-_@]{0,61}[a-zA-Z0-9-_@])?$/)]),
      'value': new FormControl(this.dnsRecordValue, DbValidators.trim),
      'aaaavalue': new FormControl(this.dnsRecordValue, DbValidators.trim),
      'ptrvalue': new FormControl(this.dnsRecordValue, DbValidators.trim),
      'srvValue': new FormControl(this.dnsRecordValue, DbValidators.trim),
      'spfValue': new FormControl(this.dnsRecordValue, DbValidators.trim),
      'txtValue': new FormControl(this.dnsRecordValue),
      'mxValue': new FormControl(this.dnsRecordValue),
      'nsValue': new FormControl('', DbValidators.trim),
      'priority': new FormControl('', [Validators.pattern(/^(0|[1-9]\d*)?$/)]),
      'type': this.type,
      'ttl': this.ttl
    });
    this.addEventHandlers();

  }


  public onFormSubmit() {
    this.formSubmitted = true;
    this.recordValue = '';
    switch (this.type.value) {
      case 'CNAME':
        this.formValid = (this.addRecordForm.controls['subdomain'].value !== '' && this.addRecordForm.controls['ptrvalue'].value !== '');
        break;
      case 'MX':
        if (this.zohoMxRecord || this.gmailMxRecord) {
          this.recordValue = this.zohoMxRecord ? this.zohoMxRecordValue : this.gmailMxRecordValue;
        } else {
          document.querySelectorAll('.db-add-dns-dialog__add-record .clone_element').forEach((el, index) => {
            if (el.querySelectorAll("input")[0].value !== "") {
              const nextElement = index !== document.querySelectorAll('.db-add-dns-dialog__add-record .clone_element').length ? "\n" : "";
              this.recordValue = this.recordValue + el.querySelectorAll("input")[0].value + ' ' + el.querySelectorAll("input")[1].value + nextElement;
            }
          });
        }
        this.formValid = this.recordValue !== '';
        break;
      case 'SRV':
        document.querySelectorAll('.db-add-dns-dialog__add-record .clone_element').forEach((el, index) => {
          if (el.querySelectorAll("input")[0].value !== "") {
            const nextElement = index !== document.querySelectorAll('.db-add-dns-dialog__add-record .clone_element').length ? "\n" : "";
            this.recordValue = this.recordValue + el.querySelectorAll("input")[0].value + ' ' + el.querySelectorAll("input")[1].value + ' ' + el.querySelectorAll("input")[2].value + ' ' + el.querySelectorAll("input")[3].value + nextElement;
          }
        });
        this.formValid = this.recordValue !== '';
        break;
      case 'PTR':
        this.formValid = this.addRecordForm.controls['ptrvalue'].value !== '';
        break;
      case 'AAAA':
        document.querySelectorAll('.db-add-dns-dialog__add-record .clone_element').forEach((el, index) => {
          const inputValue = el.querySelectorAll("input")[0].value.trim();
          if (inputValue !== "") {
            if (index > 0) {
              this.recordValue += "\n";
            }
            this.recordValue += inputValue;
          }
        });
        this.formValid = this.recordValue !== '';
        break;
      case 'A':
        document.querySelectorAll('.db-add-dns-dialog__add-record .clone_element').forEach((el, index) => {
          let inputValue = el.querySelectorAll("input")[0].value.trim();
          if (inputValue !== "") {
            if (index > 0) {
              this.recordValue += "\n";
            }
            this.recordValue += inputValue;
          }
        });
        this.formValid = this.recordValue !== '';
        break;
      case 'SPF':
        this.formValid = this.addRecordForm.controls['spfValue'].value !== '';
        break;
      case 'TXT':
        this.formValid = this.addRecordForm.controls['txtValue'].value.replace(/\s/g, '') !== '';
        break;
    }
    if (this.addRecordForm.valid && this.formValid) {
      this.loading = true;
      this.serverErrors = null;
      this.hasServerFieldErrors = false;

      if (this.record) {
        this._hostingService.updateDnsRecord(this.zone.id, this.addRecordForm.value, this.record ? this.record.id : "", this.zone.name, this.recordValue, this.website)
          .pipe(
            filter((response: DbResponse): boolean => !!response),
            first())
          .subscribe((response: any): void => {
            this.loading = false;

            if (response.success) {
              this.cancel();
              this._store.dispatch(new fromStore.LoadZone({zoneId: this.zone.id}));

            } else {
              this.checkHasServerFieldErrors(response.serverErrors);
              this.serverErrors = response.serverErrors;
              this.alreadyExistRecord = response.response && response.response.error && response.response.error.error && response.response.error.error.record ? response.response.error.error.record : null;
            }
          });
      } else {
        this._hostingService.addDnsRecord(this.zone.id, this.addRecordForm.value, this.record ? this.record.id : "", this.zone.name, this.recordValue, this.website)
          .pipe(
            filter((response: DbResponse): boolean => !!response),
            first())
          .subscribe((response: any): void => {
            this.loading = false;

            if (response.success) {
              this.cancel();
              this._store.dispatch(new fromStore.LoadZone({zoneId: this.zone.id}));

            } else {
              this.checkHasServerFieldErrors(response.serverErrors);
              this.serverErrors = response.serverErrors;
              this.alreadyExistRecord = response.response && response.response.error && response.response.error.error && response.response.error.error.record ? response.response.error.error.record : null;
            }
          });
      }
    }
  }

  public editAlreadyExistTxtRecord(): void {
    this.record = this.alreadyExistRecord;
    this.serverErrors = null;
    this.type = new FormControl(this.record ? this.record.type : (this.zohoMxRecord || this.gmailMxRecord ? "MX" : "CNAME"), [Validators.required]);
    this.ttl = new FormControl(this.record ? this.record.ttl.toString() : "3600", [Validators.required]);
    this.dnsRecordValue = this.record && this.record.value && this.record.type !== 'MX' && this.record.type !== 'SRV' && this.record.type !== 'A' && this.record.type !== 'AAAA' ? this.record.value.replace(/\"/g, "") : "";
  }


  private checkHasServerFieldErrors(serverErrors: DbServerErrors): void {
    this.hasServerFieldErrors = !!Utils.intersect(Object.keys(serverErrors.fields), ['value', 'priority', 'port', 'weight']).length;
  }


  private addEventHandlers(): void {
    this.subscriptions = [];

    this._checkIfFormValuesChanged();

    this.addRecordForm.controls['type'].valueChanges.subscribe(val => {
      this.serverErrors = null;
      this.formSubmitted = false;
      if (  typeof(document.querySelector(".cloned_element")) !== 'undefined' && document.querySelector(".cloned_element") !== null ) {
        document.querySelector('.db-add-dns-dialog__add-record').removeChild(document.querySelector('.cloned_element'));
      }
    });
  }

  private _checkIfFormValuesChanged(): void {
    const initialValue = this.addRecordForm.value
    this.addRecordForm.valueChanges.subscribe(value => {
      this.formValueChanged = Object.keys(initialValue).some(key => this.addRecordForm.value[key] !=
        initialValue[key])
    });
  }

  public cancel(): void {
    this.result = false;
    this.close();
  }

  public addOneMore(): void {
    this.indexing++;
    this.formSubmitted = true;
    let clonedElement = document.querySelector('.clone_element:last-child') !== null ? document.querySelector('.clone_element:last-child') : document.querySelector('.cloned_element:last-child');
    if (clonedElement !== null && clonedElement.querySelector('input') !== null && clonedElement.querySelector('input').value !== "") {
      let clone = <HTMLElement>clonedElement.cloneNode(true);
      clone.setAttribute('id', 'clone_element_' + this.indexing);
      clone.setAttribute('class', 'cloned_element clone_element');
      clone.querySelectorAll('input').forEach((inputItem: any): void => {
        inputItem.value = "";
      });
      const container = document.querySelector('.db-add-dns-dialog__add-record');
      const content = document.querySelector('.db-add-dns-dialog__content');
      container.appendChild(clone);
      content.scrollTo(0, container.scrollHeight);
      this.formSubmitted = false;
    }
  }

  public removeRecord($event: any): void {
    document.querySelector('.db-add-dns-dialog__add-record').removeChild($event.target.parentElement.parentElement);
  }


  override ngOnDestroy(): void {
    this.removeEventHandlers();
  }


  private removeEventHandlers(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach((subscription: Subscription): void => {
        subscription.unsubscribe();
      });
    }
    this.subscriptions = null;
  }


  public confirm(): void {
    this.loading = true;
  }

  @HostListener('document:click', ['$event']) onDocumentClick($event: any) {
    if ($event.target.classList.contains('db-icon-plus') && $event.target.parentElement.parentElement.id !== "clone_element_0") {
      this.addOneMore();
    }
    if ($event.target.classList.contains('db-icon-delete') && $event.target.parentElement.parentElement.id !== "clone_element_0") {
      this.removeRecord($event);
    }
  }

}
